import type { HTMLAttributes } from 'react';

import { classlist } from '~/_shared/design-system/lib/classlist';

import './count-badge.css';

type CountBadgeTone = 'neutral' | 'accent';

interface CountBadgeProps extends HTMLAttributes<HTMLSpanElement> {
	value: number;
	tone?: CountBadgeTone;
}

// Caps the rendered text at the 999+ convention. Callers can pass any
// non-negative number; the underlying `value` still flows through to the
// default `aria-label`.
const formatValue = (value: number): string =>
	value > 999 ? '999+' : String(value);

const CountBadge = ({
	value,
	tone = 'neutral',
	id = 'CountBadge',
	className,
	'aria-label': aria_label,
	...rest
}: CountBadgeProps) => {
	const resolved_label = aria_label ?? `${value} items`;
	return (
		<span
			{...rest}
			id={id}
			role='status'
			aria-label={resolved_label}
			className={classlist(
				'count-badge',
				`count-badge--${tone}`,
				value === 0 && 'count-badge--zero',
				className,
			)}
		>
			{formatValue(value)}
		</span>
	);
};

export type { CountBadgeProps, CountBadgeTone };
export { CountBadge };
